<template>
  <section>
    <div
      v-for="(requisiteCondition,index) in value"
      :key="index"
    >
      <AdvanceRequisiteConditionReadonly
        :value="requisiteCondition"
        :class="{'py-3 border-bottom req-cond':level===1}"
      />
    </div>
  </section>
</template>

<script>
import AdvanceRequisiteConditionReadonly from './AdvanceRequisiteConditionReadonly'

export default {
  components: {
    AdvanceRequisiteConditionReadonly,
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    level: {
      type: Number,
      default: 0,
    },
  },
}
</script>
